module.exports = function _isPlaceholder(a) {
  return a != null &&
         typeof a === 'object' &&
         a['@@functional/placeholder'] === true;
};



// WEBPACK FOOTER //
// ../~/react-toolbox/~/ramda/src/internal/_isPlaceholder.js